/**
 * Składa plik WAV (PCM, mono, 16 bit) z próbek `Int16Array` — nagranie głosu dziecka wysyłane do strojenia oceny (SPEC §23.39).
 * Ten sam format sprawdza serwer (`parseWav` w server/recordings.ts): nagłówek 44 B, 16 kHz, długość zgodna z plikiem. Bez zależności od przeglądarki.
 */
export const WAV_RATE = 16_000;

export function wavFromPcm16(pcm: Int16Array, rate: number = WAV_RATE): Uint8Array<ArrayBuffer> {
  const dataLen = pcm.length * 2;
  const out = new Uint8Array(44 + dataLen);
  const v = new DataView(out.buffer);
  const str = (at: number, s: string): void => {
    for (let i = 0; i < s.length; i++) out[at + i] = s.charCodeAt(i);
  };
  str(0, 'RIFF');
  v.setUint32(4, 36 + dataLen, true);
  str(8, 'WAVE');
  str(12, 'fmt ');
  v.setUint32(16, 16, true); // rozmiar bloku fmt
  v.setUint16(20, 1, true); // PCM
  v.setUint16(22, 1, true); // mono
  v.setUint32(24, rate, true);
  v.setUint32(28, rate * 2, true); // bajtów na sekundę
  v.setUint16(32, 2, true); // bajtów na próbkę (cała ramka mono)
  v.setUint16(34, 16, true); // bitów na próbkę
  str(36, 'data');
  v.setUint32(40, dataLen, true);
  for (let i = 0; i < pcm.length; i++) v.setInt16(44 + i * 2, pcm[i] as number, true);
  return out;
}
